/**
 * This component renders the sidebar for a club page
 * @param {object} data - All processed data about the club
 * @param {object} gradientStyle Club gradient style
 * WARNING - Currently using dummy data
 */
import React from "react";
import { useParams } from "react-router-dom";
import SingleNews from "../news/SingleNews.js";

const educationLinks = [
  {
    id: 1,
    title: "History of the BUIHA",
    author: "BUIHA Media",
    url_override: "/history",
    external: false,
  },
  /**{
    id: 1,
    title: "BUIHA Training Camps",
    author: "BUIHA Events",
    url_override: "/camps",
    external: false,
  },*/
  {
    id: 1,
    title: "Education Program Overview",
    author: "BUIHA Development",
    url_override: "/approach",
    external: false,
  },
  {
    id: 2,
    title: "Body Contact Basics",
    author: "BUIHA Development",
    url_override: "/body-contact",
    external: false,
  },
  {
    id: 3,
    title: "Skills Development Overview",
    author: "BUIHA Development",
    url_override: "/skills",
    external: false,
  },
  {
    id: 4,
    title: "Injury Prevention Guidance",
    author: "BUIHA Development",
    url_override: "/injury-prevention",
    external: false,
  },
];

const SidebarContent = ({}) => {
  const { newsId } = useParams();
  return (
    <>
      <div className="sidebar w-full flex flex-col items-center justify-start w-auto xs:m-1 xs:mx-4 pt-4 xs:mb-4 xl:mr-8 xl:px-0 px-2 xxs:px-4">
        <div className="max-w-[800px] w-full">
          <div className="flex flex-col mb-1 justify-center items-center">
            <h2 className="text-xl font-normal text-center">
              BUIHA Resources
            </h2>

            <div className="w-full h-2 my-2 bg-gradient-to-r from-blue-600 via-purple-600 to-red-600">
              <p className="hidden">Gradient line</p>
            </div>
          </div>

          <div className="max-xl:max-w-[400px] flex flex-col w-full items-start justify-start mx-auto">
            {educationLinks.map((article) => {
              if (article.id) {
                return (
                  <div
                    key={article.id}
                    className="flex flex-row max-lg:w-full mb-2 justify-start items-start"
                  >
                    <SingleNews
                      id={article.id}
                      title={article.title}
                      author={article.author}
                      img={article.img}
                      mdcontent={article.mdcontent}
                      url_override={article.url_override}
                      external={article.external}
                    />
                  </div>
                );
              }
              return null;
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default SidebarContent;
